export const GA_CLICK_ACTION = {
  ANCHOR: 'ANCHOR'
}

const GA_KEY = {
  SALE_RANKING: 'SALE_RANKING',
  SALES_PERFORMANCE: 'SALES_PERFORMANCE',
  SALE_STAT: 'SALE_STAT',
  BESTSELLER_RANKING: 'BESTSELLER_RANKING',
  CUSTOMER_INTEREST: 'CUSTOMER_INTEREST',
  PAGE_VIEWS_ANALYSIS: 'PAGE_VIEWS_ANALYSIS',
  SEARCH_KEYWORDS: 'SEARCH_KEYWORDS',
  MEMBER_ANALYSES: 'MEMBER_ANALYSES',
  BRAND_ANALYSIS: 'BRAND_ANALYSIS',
  RETURNS_ANALYSIS: 'RETURNS_ANALYSIS',
  CUSTOM_FOLLOW: 'CUSTOM_FOLLOW',
  WAREHOUSE_OVERVIEW: 'WAREHOUSE_OVERVIEW',
  CUSTOMER_INTEREST_ABANDONEDCARTS: 'CUSTOMER_INTEREST_ABANDONEDCARTS',
  CUSTOMER_INTEREST_ARRIVALNOTICE: 'CUSTOMER_INTEREST_ARRIVALNOTICE',
  CUSTOMER_INTEREST_TRACKITEM: 'CUSTOMER_INTEREST_TRACKITEM'
}

const GA_KEY_MAP = {
  [GA_KEY.SALE_RANKING]: 'ancor_salerank',
  [GA_KEY.SALES_PERFORMANCE]: 'ancor_hourlysale',
  [GA_KEY.SALE_STAT]: 'ancor_saleoverview',
  [GA_KEY.BESTSELLER_RANKING]: 'ancor_topselling',
  [GA_KEY.CUSTOMER_INTEREST]: 'ancor_customerinterest',
  [GA_KEY.PAGE_VIEWS_ANALYSIS]: 'ancor_pv',
  [GA_KEY.SEARCH_KEYWORDS]: 'ancor_keyword',
  [GA_KEY.MEMBER_ANALYSES]: 'ancor_memberAnalyses',
  [GA_KEY.BRAND_ANALYSIS]: 'ancor_brand',
  [GA_KEY.RETURNS_ANALYSIS]: 'ancor_return',
  [GA_KEY.CUSTOM_FOLLOW]: 'ancor_customFollow',
  [GA_KEY.WAREHOUSE_OVERVIEW]: 'ancor_whoverview',
  [GA_KEY.CUSTOMER_INTEREST_ABANDONEDCARTS]: 'ancor_abandoned',
  [GA_KEY.CUSTOMER_INTEREST_ARRIVALNOTICE]: 'ancor_arrivalNotice',
  [GA_KEY.CUSTOMER_INTEREST_TRACKITEM]: 'ancor_favoriteProduct'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type, payload, subItemKey } = action
  let key
  switch (type) {
    case GA_CLICK_ACTION.ANCHOR: {
      const map = [
        GA_KEY.SALE_RANKING,
        GA_KEY.SALES_PERFORMANCE,
        GA_KEY.SALE_STAT,
        GA_KEY.BESTSELLER_RANKING,
        GA_KEY.CUSTOMER_INTEREST,
        GA_KEY.PAGE_VIEWS_ANALYSIS,
        GA_KEY.SEARCH_KEYWORDS,
        GA_KEY.MEMBER_ANALYSES,
        GA_KEY.BRAND_ANALYSIS,
        GA_KEY.RETURNS_ANALYSIS,
        GA_KEY.CUSTOM_FOLLOW,
        GA_KEY.WAREHOUSE_OVERVIEW
      ]
      // when sub item click, keyPath is like ['tmp-2']['4']
      const subItemMap = {
        4: [
          GA_KEY.CUSTOMER_INTEREST_ABANDONEDCARTS,
          GA_KEY.CUSTOMER_INTEREST_ARRIVALNOTICE,
          GA_KEY.CUSTOMER_INTEREST_TRACKITEM
        ]
      }
      // if click sub item, lookup using sub item key but remove tmp-x prefix
      key = subItemKey
        ? subItemMap[payload][subItemKey.replace('tmp-', '')]
        : map[payload]
      break
    }
    default:
      break
  }
  const i13nModel = {
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
